import { credentials } from '@shootsta/client-auth';

export default function isUserAnonymousOrAuthFalsy() {
  const { auth, user } = credentials.get();
  const { isAnonymous } = user || {};

  if (!auth || isAnonymous) {return true;}

  return false;
}